var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeetingRecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 517"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 513"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 509"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M9.92861 21.1586H6.96472C5.06827 21.1586 4.12005 21.1586 3.39571 20.7895C2.75855 20.4648 2.24053 19.9468 1.91589 19.3097C1.54681 18.5853 1.54681 17.6371 1.54681 15.7407V5.35635C1.54681 4.30667 1.54681 3.78182 1.6622 3.35121C1.97531 2.18267 2.88805 1.26993 4.05659 0.956816C4.4872 0.841434 5.01205 0.841434 6.06173 0.841434H15.0916C16.1413 0.841434 16.6661 0.841434 17.0967 0.956816C18.2653 1.26993 19.178 2.18267 19.4911 3.35121C19.6065 3.78182 19.6065 4.30667 19.6065 5.35635V7.57061",
    stroke: "#00AFE7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 1",
    d: "M5.35587 10.0544H12.7252",
    stroke: "#00AFE7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 3",
    d: "M5.35587 5.67989H15.8043",
    stroke: "#00AFE7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 2",
    d: "M5.35587 14.4191H10.0096",
    stroke: "#00AFE7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    d: "M13.0351 17.672C13.0825 17.4347 13.1063 17.3161 13.1496 17.2055C13.1882 17.1073 13.2381 17.014 13.2984 16.9275C13.3664 16.83 13.4519 16.7445 13.623 16.5734L19.2093 10.9872C19.9514 10.2451 21.1545 10.2451 21.8966 10.9872C22.6387 11.7293 22.6387 12.9324 21.8966 13.6745L16.3104 19.2608C16.1393 19.4319 16.0537 19.5174 15.9563 19.5854C15.8698 19.6457 15.7765 19.6956 15.6783 19.7341C15.5677 19.7775 15.449 19.8013 15.2118 19.8487L12.4909 20.3929L13.0351 17.672Z",
    stroke: "#00AFE7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingRecord);
export default __webpack_public_path__ + "static/media/meeting-record.346c2a9ba7600fd0ab1d2e3ad10e034e.svg";
export { ForwardRef as ReactComponent };